module.exports = __webpack_public_path__ + "static/media/34-15.9cba768e.mp3";